export default __webpack_public_path__ + "static/media/Creativity-bro.526548cf.svg";